export var E_CompanyChargeMode;
(function (E_CompanyChargeMode) {
    E_CompanyChargeMode["UNKNOWN"] = "UNKNOWN";
    E_CompanyChargeMode["COMMERCIAL"] = "COMMERCIAL";
    E_CompanyChargeMode["INTERNAL"] = "INTERNAL";
    E_CompanyChargeMode["TRIAL"] = "TRIAL";
    E_CompanyChargeMode["COOPERATIVE"] = "COOPERATIVE";
    E_CompanyChargeMode["NOT_RENEW"] = "NOT_RENEW";
    E_CompanyChargeMode["FREE"] = "FREE";
})(E_CompanyChargeMode || (E_CompanyChargeMode = {}));
// 公司自动提示Source
export var E_HitCompanySource;
(function (E_HitCompanySource) {
    /**
     * 不提示
     */
    E_HitCompanySource["None"] = "None";
    /**
     * 从solr提示
     */
    E_HitCompanySource["Normal"] = "Noraml";
    /**
     * 从合作公司列表中提示
     */
    E_HitCompanySource["Cooperated"] = "Cooperated";
    /**
     * 从天眼查中提示
     */
    E_HitCompanySource["Tianyancha"] = "Tianyancha";
})(E_HitCompanySource || (E_HitCompanySource = {}));
export var E_HitCompanyTarget;
(function (E_HitCompanyTarget) {
    /**
     * 来源金融库
     */
    E_HitCompanyTarget["company_target"] = "company_target";
    /**
     * 来源bo已有公司
     */
    E_HitCompanyTarget["identity_company"] = "identity_company";
    /**
     * 来源one_id
     */
    E_HitCompanyTarget["one_id"] = "one_id";
    /**
     * all 为所有不传值
     */
    E_HitCompanyTarget["all"] = "all";
})(E_HitCompanyTarget || (E_HitCompanyTarget = {}));
(function (E_HitCompanyTarget) {
    /**
     * 默认identity_company
     * all 为所有不传值
     */
    function getTarget(target) {
        target = target || E_HitCompanyTarget.identity_company;
        if (target === E_HitCompanyTarget.all) {
            return null;
        }
        return target;
    }
    E_HitCompanyTarget.getTarget = getTarget;
})(E_HitCompanyTarget || (E_HitCompanyTarget = {}));
/**
 * 区域
 */
export var E_CompanyArea;
(function (E_CompanyArea) {
    /**
     * 东方
     */
    E_CompanyArea["east"] = "east";
    /**
     * 西方
     */
    E_CompanyArea["west"] = "west";
})(E_CompanyArea || (E_CompanyArea = {}));
export var AccountTypeOptionItemTagType;
(function (AccountTypeOptionItemTagType) {
    AccountTypeOptionItemTagType["SUCCESS"] = "success";
    AccountTypeOptionItemTagType["FAILED"] = "failed";
})(AccountTypeOptionItemTagType || (AccountTypeOptionItemTagType = {}));
export var E_CrmSource;
(function (E_CrmSource) {
    E_CrmSource["salsesforce"] = "salsesforce";
    E_CrmSource["BO_CN"] = "BO_CN";
})(E_CrmSource || (E_CrmSource = {}));
export var E_COMPANY_CREATED_FROM;
(function (E_COMPANY_CREATED_FROM) {
    E_COMPANY_CREATED_FROM["OFFICIAL_WEBSITE"] = "OFFICIAL_WEBSITE";
    E_COMPANY_CREATED_FROM["CONVERTLAB"] = "CONVERTLAB";
    E_COMPANY_CREATED_FROM["TRIAL_REQUEST"] = "TRIAL_REQUEST";
    E_COMPANY_CREATED_FROM["PURCHAS_SELF_REGISTER"] = "PURCHAS_SELF_REGISTER";
    E_COMPANY_CREATED_FROM["PHARMSNAP_FREE_REGISTER"] = "PHARMSNAP_FREE_REGISTER";
    E_COMPANY_CREATED_FROM["BO"] = "BO";
    E_COMPANY_CREATED_FROM["ADMIN_PORTAL"] = "ADMIN_PORTAL";
    E_COMPANY_CREATED_FROM["CRM"] = "CRM";
    E_COMPANY_CREATED_FROM["MINI_PROGRAME"] = "MINI_PROGRAME";
    E_COMPANY_CREATED_FROM["APP"] = "APP";
    E_COMPANY_CREATED_FROM["TWOC_COURSE"] = "2C_COURSE";
})(E_COMPANY_CREATED_FROM || (E_COMPANY_CREATED_FROM = {}));
export var E_SSO_METHODS_TOGGLE_KEY;
(function (E_SSO_METHODS_TOGGLE_KEY) {
    E_SSO_METHODS_TOGGLE_KEY["OAUTH2"] = "oauth2SsoEnabled";
    E_SSO_METHODS_TOGGLE_KEY["SAML2"] = "allow_saml_display";
    E_SSO_METHODS_TOGGLE_KEY["JWT"] = "third_login";
    E_SSO_METHODS_TOGGLE_KEY["CARSI"] = "allow_carsi_display";
    E_SSO_METHODS_TOGGLE_KEY["DING_TALK"] = "dingtalk_sso_enabled";
    E_SSO_METHODS_TOGGLE_KEY["ENTERPRISE_WECHAT"] = "wechat_enterprise_sso_enabled";
    E_SSO_METHODS_TOGGLE_KEY["FEI_SHU"] = "feishu_sso_enabled";
})(E_SSO_METHODS_TOGGLE_KEY || (E_SSO_METHODS_TOGGLE_KEY = {}));
export var EMfaListType;
(function (EMfaListType) {
    EMfaListType["WHITE_LIST"] = "WHITELIST";
    EMfaListType["BLACK_LIST"] = "BLACKLIST";
})(EMfaListType || (EMfaListType = {}));
export var E_SSO_METHODS;
(function (E_SSO_METHODS) {
    E_SSO_METHODS["OAUTH2"] = "OAUTH2";
    E_SSO_METHODS["SAML2"] = "SAML2";
    E_SSO_METHODS["JWT"] = "JWT";
    E_SSO_METHODS["CARSI"] = "CARSI";
    E_SSO_METHODS["DING_TALK"] = "DING_TALK";
    E_SSO_METHODS["ENTERPRISE_WECHAT"] = "ENTERPRISE_WECHAT";
    E_SSO_METHODS["FEI_SHU"] = "FEI_SHU";
})(E_SSO_METHODS || (E_SSO_METHODS = {}));
export var E_ExpiredPrivilegeOptions;
(function (E_ExpiredPrivilegeOptions) {
    E_ExpiredPrivilegeOptions["YES"] = "1";
    E_ExpiredPrivilegeOptions["NO"] = "0";
})(E_ExpiredPrivilegeOptions || (E_ExpiredPrivilegeOptions = {}));
export var E_WorkspaceShareType;
(function (E_WorkspaceShareType) {
    /**
     * $t('backoffice.enum.E_WorkspaceShareType.notAllowed')
     */
    E_WorkspaceShareType[E_WorkspaceShareType["notAllowed"] = 0] = "notAllowed";
    /**
     * $t('backoffice.enum.E_WorkspaceShareType.specificExternalOrganizations')
     */
    E_WorkspaceShareType[E_WorkspaceShareType["specificExternalOrganizations"] = 1] = "specificExternalOrganizations";
    /**
     * $t('backoffice.enum.E_WorkspaceShareType.allExternalOrganizations')
     */
    E_WorkspaceShareType[E_WorkspaceShareType["allExternalOrganizations"] = 2] = "allExternalOrganizations";
})(E_WorkspaceShareType || (E_WorkspaceShareType = {}));
// #region grant
export class InitGrantForm {
    constructor(authorize_patsnap = false, access_duration = '', change_password = false, export_pii_and_usage_data = false, start = '', end = '', grant_expired = true, share_type = 0, share_company_info = [], shared_company_info = []) {
        this.authorize_patsnap = authorize_patsnap;
        this.access_duration = access_duration;
        this.change_password = change_password;
        this.export_pii_and_usage_data = export_pii_and_usage_data;
        this.start = start;
        this.end = end;
        this.grant_expired = grant_expired;
        this.share_type = share_type;
        this.share_company_info = share_company_info;
        this.shared_company_info = shared_company_info;
    }
}
export var E_AuthorizationDuration;
(function (E_AuthorizationDuration) {
    E_AuthorizationDuration["TOW_HOURS"] = "2h";
    E_AuthorizationDuration["EIGHT_HOURS"] = "8h";
    E_AuthorizationDuration["ONE_DAY"] = "1d";
    E_AuthorizationDuration["THREE_DAYS"] = "3d";
    E_AuthorizationDuration["SEVEN_DAYS"] = "7d";
})(E_AuthorizationDuration || (E_AuthorizationDuration = {}));
/**
 * 登录方式
 */
export var E_LoginChannel;
(function (E_LoginChannel) {
    /**
     * $t('backoffice.enum.E_LoginChannel.wechat')
     */
    E_LoginChannel["wechat"] = "wechat";
    /**
     * $t('backoffice.enum.E_LoginChannel.account')
     */
    E_LoginChannel["account"] = "account";
    /**
     * $t('backoffice.enum.E_LoginChannel.sms')
     */
    E_LoginChannel["sms"] = "sms";
    /**
     * $t('backoffice.enum.E_LoginChannel.sso')
     */
    E_LoginChannel["sso"] = "sso";
})(E_LoginChannel || (E_LoginChannel = {}));
export var E_AcvType;
(function (E_AcvType) {
    E_AcvType["ACV_UNLIMITED_0"] = "ACV_UNLIMITED_0";
    E_AcvType["NA"] = "NA";
    E_AcvType["ACV_0_50000"] = "ACV_0_50000";
    E_AcvType["ACV_50000_100000"] = "ACV_50000_100000";
    E_AcvType["ACV_50000_UNLIMITED"] = "ACV_50000_UNLIMITED";
    E_AcvType["ACV_100000_UNLIMITED"] = "ACV_100000_UNLIMITED";
})(E_AcvType || (E_AcvType = {}));
export var CUSTOMER_AI_REPORT_FEEDBACK_OPERATE;
(function (CUSTOMER_AI_REPORT_FEEDBACK_OPERATE) {
    CUSTOMER_AI_REPORT_FEEDBACK_OPERATE["LIKE"] = "LIKE";
    CUSTOMER_AI_REPORT_FEEDBACK_OPERATE["DISLIKE"] = "DISLIKE";
})(CUSTOMER_AI_REPORT_FEEDBACK_OPERATE || (CUSTOMER_AI_REPORT_FEEDBACK_OPERATE = {}));
export var SSEResponseStatus;
(function (SSEResponseStatus) {
    SSEResponseStatus["READY"] = "READY";
    SSEResponseStatus["FINISH"] = "FINISH";
    SSEResponseStatus["PROCESSING"] = "PROCESSING";
    SSEResponseStatus["FAILED"] = "FAILED";
})(SSEResponseStatus || (SSEResponseStatus = {}));
